import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ProcessSection from './components/ProcessSection';
import CTASection from './components/CTASection';
import TakeoffServices from './components/TakeoffServices';
import ToolsSection from '../../components/feature/ToolsSection';

export default function ServicesPage() {

  return (
    <div className="min-h-screen bg-white dark:bg-slate-900 transition-colors duration-300">
      <Header />
      <main>
        <TakeoffServices />
        <ToolsSection />
        <ProcessSection serviceType="takeoff" />
        <CTASection serviceType="takeoff" />
      </main>
      <Footer />
    </div>
  );
}